import { html } from "lit";
import { getDummyText } from "../../../utils";
import {
    TemplateWithSlider,
    highlights,
} from "../../partial-templates/highlights/highlights.stories";
import { productSliderZoom } from "../../partial-templates/slider/slider.stories";

export const extendedPage = (content, args) => {
    return html`${extendedPageContent(content, args)} `;
};

const extendedPageContent = (content, args) => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col">
                    ${productSliderZoom()}
                </div>
            </div>
        </div>
        ${TemplateWithSlider({
            ...args,
            highlights: [highlights[4], highlights[5], highlights[6]],
            noLink: true,
            bodytext: getDummyText(460),
        })}
        ${tabsTemplate(content, args)}
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col">
                    <ux-iws-notification-bar
                        icon-name="globe"
                        background="green"
                    >
                        <h2
                            class="ux-text-headline ux-text-headline--medium"
                            slot="title"
                        >
                            Lorem ipsum dolor sit amet, consetetur.
                        </h2>
                        <div class="ux-text-normal" slot="copy">
                            <p>
                                Lorem ipsum dolor sit amet, consetetur
                                sadipscing elitr, sed diam nonumy eirmod tempor
                                invidunt ut labore et dolore magna aliquyam
                                erat, sed diam voluptua. At vero eos et accusam
                                et justo duo dolores et ea rebum. Stet clita
                                kasd gubergren, no sea takimata sanctus est.
                                Lorem ipsum dolor sit amet, consetetur
                                sadipscing elitr, sed diam nonumy eirmod tempor
                                invidunt ut labore et dolore magna aliquyam
                                erat, sed diam voluptua. At vero eos et accusam.
                            </p>
                        </div>
                        <a class="btn " href="#">
                            Mehr erfahren
                        </a>
                    </ux-iws-notification-bar>
                </div>
            </div>
        </div>
    `;
};

const tabsTemplate = (content, args) => {
    return html`
        <div class="ux-t-container">
            <div class="ux-row ux-u-pt-fluid-l">
                <div class="ux-col">
                    <ux-tab-container
                        id="product-tabs"
                        active-tab-id="green-market-form"
                        fix-to-top
                        scroll-when-activated
                    >
                        <ux-tab name="Tab navigation 1" tab-id="1">
                            <div class="ux-u-mt-fluid-xs ux-u-mb-fluid-xs">
                                <h3
                                    class="ux-text-headline ux-text-headline--medium"
                                >
                                    Rhoncus rutrum velit
                                </h3>
                                <p>${getDummyText(800)}</p>
                            </div>
                        </ux-tab>
                        <ux-tab name="Tab navigation 2" tab-id="2">
                            <div class="ux-u-mt-fluid-xs ux-u-mb-fluid-xs">
                                <h3
                                    class="ux-text-headline ux-text-headline--medium"
                                >
                                    Lorem ipsum
                                </h3>
                                <button class="ux-button">Lorem ipsum</button>
                            </div>
                        </ux-tab>
                        <ux-tab name="Tab navigation 3" tab-id="3">
                            <div class="ux-u-mt-fluid-xs ux-u-mb-fluid-xs">
                                <h3
                                    class="ux-text-headline ux-text-headline--medium"
                                >
                                    Mi platea
                                </h3>
                                <p>${getDummyText(800)}</p>
                            </div>
                        </ux-tab>
                        <ux-tab
                            name="green market form"
                            tab-id="green-market-form"
                        >
                            <div class="ux-u-mt-fluid-xs ux-u-mb-fluid-xs">
                                ${content}
                            </div>
                        </ux-tab>
                    </ux-tab-container>
                </div>
            </div>
        </div>
        ${args.showTestMessage && args.step === 1
            ? html`
                  <ux-modal
                      name="modal-notice-storybook-dev-env"
                      class="notice-modal"
                  >
                      <ux-modal-content class="ux-u-text-align--center">
                          <ux-icon
                              name="triangle-warning"
                              size-s="50"
                              weight="light"
                              class="ux-color-warning"
                          >
                          </ux-icon>
                          <div class="ux-row">
                              <div class="ux-col ux-col-md-10 ux-u-offset-md-1">
                                  <div
                                      class="ux-text-headline ux-text-headline--medium ux-u-margin-vertical-20"
                                  >
                                      This is a non-production environment
                                  </div>
                                  <div
                                      class="ux-text-normal ux-text-normal--light-gray"
                                  >
                                      The functionality displayed on this page
                                      are to be taken as an initial showcase of
                                      the intended functionality, in order to
                                      give the stakeholder a more concrete idea
                                      of the feature. The actual behaviour of
                                      the feature in the production system may
                                      differ slightly depending on further
                                      requirements and technical
                                      specifications/limitations of the system
                                      itself. Among others, these are things you
                                      might notice in this test environment:
                                  </div>
                                  <div>
                                      <ul class="ux-list">
                                          <li>
                                              Images might be missing, wrong,
                                              blurred, or low quality
                                          </li>
                                          <li>
                                              Texts might be missing, wrong or
                                              be lorem ipsum placeholders
                                          </li>
                                          <li>
                                              There is no validation of the form
                                              elements, i.e., elements that
                                              should (and will) be required are
                                              not marked as such and it is
                                              possible to send the form without
                                              filling these in.
                                          </li>
                                          <li>
                                              The content of the other tabs is
                                              not present (only dummy text is
                                              present).
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </ux-modal-content>
                      <ux-modal-footer>
                          <button
                              class="ux-button"
                              data-trigger-modal="close,modal-notice-storybook-dev-env"
                          >
                              understood
                          </button>
                      </ux-modal-footer>
                  </ux-modal>
              `
            : html``}
    `;
};
